import { useApiService } from '../services/apiServices';

const useAffidavitService = () => {
    const handleApiRequest = useApiService();


    const fetchAllAffidavitData = async (page = 1, pageSize = 20) => {
        try {
            let affidavitResponse = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/affidavit/all?page=${page}&pageSize=${pageSize}`,
                "GET"
            );
            return affidavitResponse;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    };

    const fetchMyAffidavitData = async (page = 1, pageSize = 20, status = null) => {
        try {
            let affidavitResponse = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/affidavit/myrequests?page=${page}&pageSize=${pageSize}${status ? `&status=${status}` : ''}`,
                "GET"
            );
            return affidavitResponse;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    };

        const fetchAffidavitByFilter = async (criteria = {}, page = 1, pageSize = 20) => {
        try {
            const params = new URLSearchParams({ page, pageSize });
            if (criteria.documentId) params.append("DocumentId", criteria.documentId);
            if (criteria.deponentName) params.append("DeponentName", criteria.deponentName);
            if (criteria.courtName) params.append("CourtName", criteria.courtName);
            if (criteria.courtDivision) params.append("CourtDivision", criteria.courtDivision);
            if (criteria.startDate) params.append("StartDate", criteria.startDate);
            if (criteria.endDate) params.append("EndDate", criteria.endDate);
            if (criteria.status) params.append("Status", criteria.status);
            if (criteria.user) params.append("User", criteria.user);
 
           

            let affidavitResponse = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/affidavit/filter?${params.toString()}`,
                "GET"
            );
            return affidavitResponse;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    };

    const fetchAllCourts = async (onlyWithRecords = false, isAdmin = false) => {
        try {
            const params = new URLSearchParams();
            if (onlyWithRecords) params.append("onlyWithRecords", "true");
            if (isAdmin) params.append("isAdmin", "true");
            const query = params.toString();
            const courtResponse = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/court/all${query ? `?${query}` : ""}`,
                "GET"
            );
            return courtResponse;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    };
    const fetchAllCourtDivisions = async (onlyWithRecords = false, isAdmin = false) => {
        try {
            const params = new URLSearchParams();
            if (onlyWithRecords) params.append("onlyWithRecords", "true");
            if (isAdmin) params.append("isAdmin", "true");
            const query = params.toString();
            const courtDivisionResponse = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/court/divisions/all${query ? `?${query}` : ""}`,
                "GET"
            );
            return courtDivisionResponse;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    };

    const fetchAllAdmin = async () => {
        try {
            let adminResponse = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/admin/all`,
                "GET"
            );
            console.log("Admin response:", adminResponse);
            return adminResponse;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    };

    return { fetchAllAffidavitData, fetchMyAffidavitData, fetchAffidavitByFilter, fetchAllCourts,fetchAllCourtDivisions,fetchAllAdmin};
};

export default useAffidavitService;